/**
 * The class representing the {@link Ball}
 */
var Ball = /** @class */ (function () {
    /**
     * @param colors Colors Tab
     */
    function Ball(colors) {
        this.color = colors.length == 1 ? colors[0] : 'all';
        this.div = document.createElement('div');
        this.div.classList.add('ball');
        this.div.style.background = "conic-gradient(" + colors.map(function (e, i, a) { return a.length > 1 ? e : e + ", " + e; }) + ")";
        this.isActive = false;
    }
    /** @inheritdoc */
    Ball.prototype.addClass = function (className) {
        this.div.classList.add(className);
    };
    /** @inheritdoc */
    Ball.prototype.removeClass = function (className) {
        this.div.classList.remove(className);
    };
    return Ball;
}());
export { Ball };
